import ExaminationBoardModel from '@/dex-shared/models/ExaminationBoardModel';

export default {
  examinationBoardById: (state: any, getters: any) => (
    examinationBoardId: number,
  ) => {
    const examinationBoard = state.examination_boards[examinationBoardId];
    if (examinationBoard)
      return new ExaminationBoardModel(examinationBoard, getters);
    return {};
  },
  allExaminationBoards: (state: any, getters: any) => {
    return Object.values(state.examination_boards).map(
      (examinationBoard: any) =>
        new ExaminationBoardModel(examinationBoard, getters),
    );
  },
};
